<template>
  <facial-features-template
    :gender="gender"
    :eye-color="eyeColor"
    :natural-hair-color="naturalHairColor"
    :field-errors="fieldErrors"
    @field-change="onFieldChange"
  />
</template>

<script>
import FacialFeaturesTemplate from '@/modules/questionnaire/components/steps/common/identity/facial-features/FacialFeaturesTemplate';

import { makeStep, resetStoreValues } from '@/modules/questionnaire/mixins';
import { fieldBuilder } from '@/modules/questionnaire/mixins/makeStep';

const fieldsToReset = ['skinColor'];

const { field, requiredField } = fieldBuilder;

const FIELDS = [
  field('gender'),
  requiredField('eyeColor'),
  requiredField('naturalHairColor'),
  field('skinColor')
];

export default {
  name: 'FacialFeatures',
  components: {
    FacialFeaturesTemplate
  },
  mixins: [makeStep(FIELDS), resetStoreValues],
  watch: {
    eyeColor(newValue, oldValue) {
      if (!oldValue && this.naturalHairColor) {
        this.showNextStep();
      } else {
        this.scrollTo('#hair-color');
      }
    },
    naturalHairColor(newValue, oldValue) {
      this.resetStoreFieldsByName(fieldsToReset);

      if (!oldValue && this.eyeColor) {
        this.showNextStep();
      }
    }
  }
};
</script>
